if (window.jQuery) {
  $(document).ready(function () {
    console.log('working');
    $('.btn-buynow').on('click', function () {
      const $button = $(this);
      const $quickBuy = $button.closest('.bls__product-item');
      const productJson = $quickBuy.find('.productinfo').text();
      const $quickBuyParent = $button.closest('quick-buy');

      if ($quickBuyParent.length === 0) return;

      const variantId = $quickBuyParent.data('product-variant-id');
      if (!variantId) {
        alert('Variant not available');
        return;
      }

      let productData;
      try {
        productData = JSON.parse(productJson);
      } catch (e) {
        console.error('Failed to parse product JSON:', e);
      }
      console.log(productData);
      if ( productData == undefined ) {
        const variant = $button.parents('.bls__product-addtocart-js').data('product-variant-id');
        console.log(variant);
      } else {
        const variant = productData.find(v => String(v.id) === String(variantId));
        if (!variant) {
          alert('Variant data not found');
          return;
        }

        if (!variant.available) {
          alert('This product is out of stock.');
          return;
        }
      }

      // Add loader and class
      const $loader = $('<span class="loader-icon"></span>');
      $button.append($loader);
      $button.addClass('btn-loading').prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({
          id: variantId,
          quantity: 1
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function () {
          window.location.href = '/checkout'; // Optional redirect
        },
        error: function (xhr, status, error) {
          console.error('Error:', error);
          alert('Could not complete purchase. Please try again.');
        },
        complete: function () {
          $loader.remove();
          $button.removeClass('btn-loading').prop('disabled', false);
        }
      });
    });
  });
} else {
  console.warn('jQuery not loaded. Buy Now functionality will not work.');
}
